module.exports = __webpack_public_path__ + "img/help-image-en.5b50b51f.png";